import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import EventComp from "../../component/servicescomponent/EventComp";

const Event = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <EventComp />
        <Footer />
      </section>
    </>
  );
};

export default Event;
